import camelize from 'camelize'

import BaseModel from './BaseModel'

import { USER_FETCHED } from '../redux/actions/users'

class User extends BaseModel {
  static reducer(action, User) {
    switch (action.type) {
      case USER_FETCHED:
        User.create(action.user)
        break
    }
    return undefined
  }

  static getCurrentUser() {
    // We use a globalUserFetch promise to syncronize between Angular and React calls to /users/me. (cf. app/assets/angular/legacy/legacy.module.coffee)
    // First we check if the globalUserFetch promise was set, if Angular and React are both used Angular will ALWAYS run first.
    // However, we can use withRedux() and withUser() outside of Angular, so we need to run our own promise here too.

    if (!window.globalUserFetch) {
      window.globalUserFetch = new Promise((resolve, reject) => {
        fetch('/api/v2/users/me')
          .then(data => {
            // We can only resolve the body stream into JSON once, otherwise it will throw an error.
            // https://stackoverflow.com/questions/53511974/javascript-fetch-failed-to-execute-json-on-response-body-stream-is-locked
            return data.json()
          })
          .then(data =>
            // The Angular promise returns the data as {data: ...}. So that our consumer can be the same, we manipulate the Promise resolution to mimic that given by Angular here.
            resolve({ data })
          )
          .catch(response => {
            reject(response)
          })
      })
    }

    return window.globalUserFetch
      .then(data => {
        return camelize(data.data)
      })
  }

  isAdmin() {
    return this.admin
  }

  isPlaylistAuthor(authorUsername) {
    return this.username === authorUsername
  }
}

User.modelName = 'User'
User.apiPath = '/users'
User.options = {
  idAttribute: 'username'
}

export default User
